import React, { useState, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Skeleton } from 'primereact/skeleton';
import { API_GET_ALL_METADATA } from '../../api/metadata.service';
import { useUtility } from '../../context/UtilityContext';
import { formatMobNumber, capitalizeFLetter } from '../../utils/commonUtils';

const MetadataDropdown = ({ className = '', showLabel = true }) => {
  const [metadataList, setMetadataList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { selectedMetadataId, setSelectedMetadataId } = useUtility();

  useEffect(() => {
    const fetchMetadata = async () => {
      try {
        setLoading(true);
        setError(null);
        const res = await API_GET_ALL_METADATA(0, 50);
        setMetadataList(res.rows || []);
      } catch (err) {
        console.error('Failed to fetch metadata:', err);
        setError('Failed to load WhatsApp accounts');
      } finally {
        setLoading(false);
      }
    };

    fetchMetadata();
  }, []);

  if (loading) {
    return (
      <div className={`flex align-items-center gap-2 ${className}`}>
        <Skeleton width="12rem" height="2.5rem" />
      </div>
    );
  }

  if (error) {
    return (
      <div className={`flex align-items-center gap-2 ${className}`}>
        <span className="text-red-500">{error}</span>
      </div>
    );
  }

  if (!metadataList.length) {
    return (
      <div className={`flex align-items-center gap-2 ${className}`}>
        <span>No WhatsApp accounts found</span>
      </div>
    );
  }

  const dropdownOptions = metadataList.map((meta) => {
    return {
      value: String(meta.id),
      label: (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <span>{capitalizeFLetter(meta?.name) || 'Unknown'}</span>
          <span>{formatMobNumber(meta?.phoneNumber)}</span>
        </div>
      ),
    };
  });

  return (
    <div className={`flex align-items-center gap-2 ${className}`}>
      {showLabel && <label className="font-semibold text-sm text-color-secondary">Accounts:</label>}

      <Dropdown
        value={selectedMetadataId}
        options={dropdownOptions}
        onChange={(e) => setSelectedMetadataId(e.value)}
        placeholder="Select WhatsApp Account"
        className="w-full md:w-20rem"
      />
    </div>
  );
};

export default MetadataDropdown;
